import React from "react"
import PropTypes from "prop-types"
import JobSuggestionItem from "./JobSuggestionItem"

/**
 * JobSuggestionList displays a list of suggested job services
 *
 * @param {Object} props
 * @param {Array} props.suggestions - Array of suggested job services
 * @param {Function} props.onSelectJob - Callback when a job is selected
 * @param {boolean} props.isAssigning - Whether an assignment is in progress
 */
export default function JobSuggestionList({ suggestions, onSelectJob, isAssigning }) {
  if (!suggestions || suggestions.length === 0) {
    return null
  }

  return (
    <div className="job-suggestion-list-container">
      <div className="job-suggestion-list">
        {suggestions.map((suggestion, index) => (
          <JobSuggestionItem
            key={suggestion.id}
            suggestion={suggestion}
            rank={index + 1}
            onSelect={onSelectJob}
            isDisabled={isAssigning} />
        ))}
      </div>
    </div>
  )
}

JobSuggestionList.propTypes = {
  suggestions: PropTypes.arrayOf(
    PropTypes.shape({
      id: PropTypes.number.isRequired,
      job_no: PropTypes.string,
      address: PropTypes.string,
      booking_date: PropTypes.string,
      estimated_hours: PropTypes.number,
      price: PropTypes.number,
      booking_time: PropTypes.string,
      value_per_hour: PropTypes.number,
      fit_score: PropTypes.number
    })
  ).isRequired,
  onSelectJob: PropTypes.func.isRequired,
  isAssigning: PropTypes.bool
}

JobSuggestionList.defaultProps = {
  isAssigning: false
}
